import { Typography } from "@mui/material";

export default function TooltipLineItem({ label, value }) {
  return (
    <p className="my-1">
      <Typography component="span" className="text-xs font-bold text-black">
        {label}
      </Typography>{" "}
      {value}
    </p>
  );
}
